"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgFacebookWhite = function () {
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.477 2 2 6.504 2 12.059c0 5.02 3.657 9.182 8.438 9.937v-7.03h-2.54V12.06h2.54V9.843c0-2.521 1.492-3.914 3.777-3.914 1.094 0 2.238.197 2.238.197V8.6h-1.26c-1.243 0-1.63.776-1.63 1.571v1.887h2.773l-.443 2.908h-2.33v7.029C18.343 21.24 22 17.08 22 12.059 22 6.504 17.523 2 12 2Z", fill: "#fff" }));
};
exports.default = factorySvgIcon_1.default(SvgFacebookWhite);
//# sourceMappingURL=SvgFacebookWhite.js.map